import { Modal } from 'react-bootstrap'
import { SubscriptionPlanSelector } from './subscriptionPlanSelector'

interface SubscriptionModalProps {
  show: boolean
  onHide: () => void
  title?: string
  message?: string
  successUrl?: string
  cancelUrl?: string
  /** Tier to preselect in the plan selector (e.g. 'family' when the blocked action needs the Family plan) */
  preselectTier?: string
}

export function SubscriptionModal({
  show,
  onHide,
  title = 'Subscribe to Continue',
  message = 'Get full access to all features with a subscription.',
  successUrl = window.location.href,
  cancelUrl = window.location.href,
  preselectTier,
}: SubscriptionModalProps) {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
        <SubscriptionPlanSelector
          successUrl={successUrl}
          cancelUrl={cancelUrl}
          onSubscribe={onHide}
          preselectTier={preselectTier}
        />
      </Modal.Body>
    </Modal>
  )
}
